<template>
  <emd-modal
    :open="isOpen"
    has-header
    has-footer
    @close="() => $emit('onCancel')"
  >
    <template v-slot:header>
      <h2 class="emd-text _size_section">
        {{ title }}
      </h2>
    </template>
    <template v-slot:content>
      <div class="eu-display_flex eu-mt_2">
        <p>
          {{ textParagraph[0] }}
          <strong>{{ textParagraph[1] }}</strong>
          {{ textParagraph[2] }}
        </p>
      </div>
      <p
        v-if="resetText"
        class="eu-mt_4 _paragraph_color_success"
      >
        {{ resetText }}
      </p>
    </template>
    <template v-slot:footer>
      <div class="eu-display_flex eu-justify_end eu-width_100">
        <emd-button
          data-testid="button-cancel"
          color="primary"
          type="text"
          @click="$emit('onCancel')"
          :text="$t('modal.reset-secret-key.modal-confirm.button-1')"
        />
        <emd-button
          data-testid="button-reset-secret-key"
          color="success"
          @click="$emit('onSubmit')"
        >
          <span>
            {{ textSubimit }}
          </span>
        </emd-button>
      </div>
    </template>
  </emd-modal>
</template>

<style scoped>
._paragraph_color_success {
  color: var(--brand--le--primary-color--base);
}
</style>

<script>
import { EmdModal, EmdButton } from 'emerald-vue/src/components'

export default {
  name: 'ModalDefaultReset',
  components: {
    EmdModal,
    EmdButton
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    error: [String, null],
    title: String,
    textParagraph: [Array, String],
    textSubimit: String,
    resetText: [Boolean, String]
  }
}
</script>
